import { Button, CircularProgress, Backdrop, TextField, makeStyles, withStyles } from "@material-ui/core";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { useSnackbar } from "notistack";
import ReactGa from 'react-ga';

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("sm")]: {
            margin: '2rem auto 0 auto',
            padding: '1rem 2rem',
            flexDirection: 'column',
        },
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center',
        alignItems: 'baseline',
        padding: '2rem 6rem',
        margin: '5rem auto 0 auto',
        width: '100%',
        background: '#315CD5 !important',
        color: '#fff',
        position: 'relative',
        '& div': {
            [theme.breakpoints.down("sm")]: {
                width: '100%',
            },
            flexBasis: '50%'
        }
    },
    borderColor: {
        borderColor: 'orange'
    },
    connectUsForm: {
        '& label, input': {
            color: 'white !important',
        },
        '& form': {
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
        },
        '& button': {
            [theme.breakpoints.down("sm")]: {
                width: '100%',
            },
            color: '#fff',
            textTransform: 'none',
            background: '#171717 !important',
            padding: '1rem',
            borderRadius: '8px',
            height: '3rem',
            maxWidth: 'fit-content',
            marginRight: '10px',
            '&:hover': {
                background: '#030303'
            },
            '& img': {
                width: '0.8rem',
                marginBottom: '-1px',
            }
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    circularLoader: {
        width: "60px",
        height: "60px",
        position: "absolute",
        margin: "0 auto",
        top: "50%",
        left: "0",
        right: "0",
        zIndex: 1
    },
    buttonWithInfo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    highlightText: {
        color: '#FFB8C0'
    }
}))


const CustomisedTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: 'white',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'white',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'white',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'white',
            },
        },
    },
})(TextField);


const ConnectUs = () => {

    const classes = useStyles();
    const { trackname } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const initlialFormValue = {
        name: '',
        email: '',
        question: '',
        track: trackname
    }
    const [formData, setFormData] = useState(initlialFormValue);
    const [loading, setLoading] = useState(false)

    const handleOnChange = (val, name) => {
        setFormData((prev) => ({ ...prev, [name]: val }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        ReactGa.event({
            category: 'Button',
            action: 'User clicked on connect with us for unlimited plan'
        });
        axiosInstance.post("users", { ...formData })
            .then(() => {
                enqueueSnackbar(`Data Saved. We'll contact you soon!`, {
                    variant: 'success',
                    autoHideDuration: 2500,
                });
            })
            .catch(() => {
                enqueueSnackbar(`Some error occurred please try again after some time.`, {
                    variant: 'error',
                    autoHideDuration: 10000,
                });
            })
            .finally(() => {
                setFormData(initlialFormValue);
                setLoading(false);
            })
    }

    return (
        <>
            <section className={classes.root}>
                <Backdrop open={loading} className={classes.backdrop}>
                    <CircularProgress className={classes.circularLoader} />
                </Backdrop>
                <div>
                    <h1>Have a question?</h1>
                    <p>Fill out the form below, and one of our Learning Advisors will reach out to you within
                        <span className={classes.highlightText}> 24 working hours</span>.</p>
                </div>
                <div className={classes.connectUsForm}>
                    <form onSubmit={handleSubmit}>
                        <CustomisedTextField
                            label="Type your full name"
                            variant="outlined"
                            required
                            value={formData.name}
                            onChange={(e) => handleOnChange(e.target.value, 'name')}
                        />
                        <CustomisedTextField
                            label="Email Address"
                            variant="outlined"
                            required
                            type="email"
                            value={formData.email}
                            onChange={(e) => handleOnChange(e.target.value, 'email')}
                        />
                        <CustomisedTextField
                            label="Write your question here"
                            variant="outlined"
                            required
                            value={formData.question}
                            onChange={(e) => handleOnChange(e.target.value, 'question')}
                        />
                        <div>
                            <Button type="submit">
                                <span>Submit</span>
                            </Button>
                            <span style={{
                                color: '#91A8E9'
                            }}>Your personal data is safe with us</span>
                        </div>
                    </form>
                </div>
            </section>
        </>
    )
}

export default ConnectUs;